module.exports = __webpack_public_path__ + "img/examination.a5c8d10b.png";